import request from "@/utils/request";

export default function agentSendToAccessControlDeviceWithOutBack(data) {
  return request.post(
    `/device/accessControlDirectMsg/agent/sendToAccessControlDeviceWithOutBack`,
    data
  );
}
